export const GET_EDOCUMENTATION_UNDERGRADUATE = "GET_EDOCUMENTATION_UNDERGRADUATE"
export const GET_EDOCUMENT_TYPES = "GET_EDOCUMENT_TYPES"
export const UPLOADING_EDOCUMENTATION_DOC = "UPLOADING_EDOCUMENTATION_DOC"
export const CLEARANCE_REQUESTS = "CLEARANCE_REQUESTS"
export const DOCUMENTS_HISTORY = "DOCUMENTS_HISTORY"
export const CLEAR_STATE = "CLEAR_STATE"